import React from "react";
import { UserAvatar } from "../userAvatar/UserAvatar";
import { Avatar } from "../../types/types";

type props = {
  avatar: Avatar[];
};

export const PayForAllAvatars: React.FC<props> = ({ avatar }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}>
        {avatar?.[0] && (
          <UserAvatar
            avatar={{ name: avatar[0]?.name, image: avatar[0]?.image }}
            size={18}
            nameStyle={{ fontSize: 7, paddingBottom: 0 }}
          />
        )}
        {avatar?.[3] && (
          <UserAvatar
            avatar={{ name: avatar?.[3]?.name, image: avatar?.[3]?.image }}
            size={18}
            nameStyle={{ fontSize: 7, paddingBottom: 0 }}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}>
        {avatar?.[1] && (
          <UserAvatar
            avatar={{ name: avatar[1]?.name, image: avatar[1]?.image }}
            size={18}
            nameStyle={{ fontSize: 7, paddingBottom: 0 }}
          />
        )}
        {avatar?.[2] && (
          <UserAvatar
            avatar={{ name: avatar[2]?.name, image: avatar[2]?.image }}
            size={18}
            nameStyle={{ fontSize: 7, paddingBottom: 0 }}
          />
        )}
      </div>
    </div>
  );
};
